<template>
  <promotion-list></promotion-list>
</template>

<script>
import PromotionList from '@/components/promotions/List'

export default {
  components: {
    PromotionList
  }
}
</script>


// WEBPACK FOOTER //
// src/pages/Home.vue